<template>
  <div
    class="sticky bottom-4 mb-4
           mx-auto
           sm:ml-auto sm:mr-4
           px-6 py-2.5 rounded-full bg-science-blue-20 text-center font-bold
           shadow-[0_6px_28px_0_rgba(84,88,90,0.2)] border-2 border-science-blue-100
           whitespace-nowrap w-max"
  >
    {{ remainingFileSizeMB  }} MB left out of 800.00MB
  </div>
</template>

<script setup lang="ts">
interface Props {
  remainingFileSizeMB: number
}
defineProps<Props>()
</script>
